import React from 'react'
import { Link } from 'react-router-dom'

function CartInner() {
    return (
        <main className="ms-main">
            <div className="ms-page-content">
                {/*================= Cart Area Start =================*/}
                <article
                    id="post-283"
                    className="post-283 page type-page status-publish hentry"
                >
                    <div className="ms-default-page container">
                        <div className="woocommerce">
                            <div className="woocommerce-notices-wrapper" />
                            <div className="ms-woocommerce-cart-form-wrapper">
                                <table className="shop_table shop_table_responsive cart woocommerce-cart-form__contents">
                                    <thead>
                                        <tr>
                                            <th className="product-remove">&nbsp;</th>
                                            <th className="product-thumbnail">&nbsp;</th>
                                            <th className="product-name">Product</th>
                                            <th className="product-price">Price</th>
                                            <th className="product-quantity">Quantity</th>
                                            <th className="product-subtotal">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="woocommerce-cart-form__cart-item cart_item">
                                            <td className="product-remove">
                                                <Link
                                                    to="#"
                                                    className="remove"
                                                    aria-label="Remove this item"
                                                    data-product_id={470}
                                                    data-product_sku={161056}
                                                >
                                                    <svg
                                                        viewBox="0 0 200 200"
                                                        width={18}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"></path>
                                                    </svg>
                                                </Link>
                                            </td>
                                            <td className="product-thumbnail">
                                                <Link to="#">
                                                    <img
                                                        src="/assets/images/room/1.webp"
                                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                                        alt=""
                                                    />
                                                </Link>
                                            </td>
                                            <td className="product-name" data-title="Product">
                                                <Link to="#">The Ritz-Carlton</Link>
                                            </td>
                                            <td className="product-price" data-title="Price">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        120.00
                                                    </bdi>
                                                </span>
                                            </td>
                                            <td>
                                                <div className="cart-edit">
                                                    <div className="quantity-edit">
                                                        <button className="button">
                                                            -
                                                        </button>
                                                        <input type="text" className="input" defaultValue={3} />
                                                        <button className="button plus">
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="product-subtotal" data-title="Subtotal">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        120.00
                                                    </bdi>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr className="woocommerce-cart-form__cart-item cart_item">
                                            <td className="product-remove">
                                                <Link
                                                    to="#"
                                                    className="remove"
                                                    aria-label="Remove this item"
                                                    data-product_id={476}
                                                    data-product_sku={321736}
                                                >
                                                    <svg
                                                        viewBox="0 0 200 200"
                                                        width={18}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"></path>
                                                    </svg>
                                                </Link>
                                            </td>
                                            <td className="product-thumbnail">
                                                <Link to="#">
                                                    <img
                                                        src="/assets/images/room/2.webp"
                                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                                        alt="Shop"
                                                    />
                                                </Link>
                                            </td>
                                            <td className="product-name" data-title="Product">
                                                <Link to="#">Four Seasons Hotels</Link>
                                            </td>
                                            <td className="product-price" data-title="Price">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        180.00
                                                    </bdi>
                                                </span>
                                            </td>
                                            <td>
                                                <div className="cart-edit">
                                                    <div className="quantity-edit">
                                                        <button className="button">
                                                            -
                                                        </button>
                                                        <input type="text" className="input" defaultValue={3} />
                                                        <button className="button plus">
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="product-subtotal" data-title="Subtotal">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        180.00
                                                    </bdi>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr className="woocommerce-cart-form__cart-item cart_item">
                                            <td className="product-remove">
                                                <Link
                                                    to="#0"
                                                    className="remove"
                                                    aria-label="Remove this item"
                                                    data-product_id={478}
                                                    data-product_sku={117652}
                                                >
                                                    <svg
                                                        viewBox="0 0 200 200"
                                                        width={18}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"></path>
                                                    </svg>
                                                </Link>
                                            </td>
                                            <td className="product-thumbnail">
                                                <Link to="#">
                                                    <img
                                                        src="/assets/images/room/3.webp"
                                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                                        alt="Shop"
                                                    />
                                                </Link>
                                            </td>
                                            <td className="product-name" data-title="Product">
                                                <Link to="#">Waldorf Astoria Hotels</Link>
                                            </td>
                                            <td className="product-price" data-title="Price">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        80.00
                                                    </bdi>
                                                </span>
                                            </td>
                                            <td>
                                                <div className="cart-edit">
                                                    <div className="quantity-edit">
                                                        <button className="button">
                                                            -
                                                        </button>
                                                        <input type="text" className="input" defaultValue={3} />
                                                        <button className="button plus">
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="product-subtotal" data-title="Subtotal">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        80.00
                                                    </bdi>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr className="woocommerce-cart-form__cart-item cart_item">
                                            <td className="product-remove">
                                                <Link
                                                    to="#0"
                                                    className="remove"
                                                    aria-label="Remove this item"
                                                    data-product_id={483}
                                                    data-product_sku=""
                                                >
                                                    <svg
                                                        viewBox="0 0 200 200"
                                                        width={18}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"></path>
                                                    </svg>
                                                </Link>
                                            </td>
                                            <td className="product-thumbnail">
                                                <Link to="#">
                                                    <img
                                                        src="/assets/images/room/4.webp"
                                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                                        alt=""
                                                    />
                                                </Link>
                                            </td>
                                            <td className="product-name" data-title="Product">
                                                <Link to="#">Deluxe Room</Link>
                                            </td>
                                            <td className="product-price" data-title="Price">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        139.00
                                                    </bdi>
                                                </span>
                                            </td>
                                            <td>
                                                <div className="cart-edit">
                                                    <div className="quantity-edit">
                                                        <button className="button">
                                                            -
                                                        </button>
                                                        <input type="text" className="input" defaultValue={3} />
                                                        <button className="button plus">
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="product-subtotal" data-title="Subtotal">
                                                <span className="woocommerce-Price-amount amount">
                                                    <bdi>
                                                        <span className="woocommerce-Price-currencySymbol">
                                                            $
                                                        </span>
                                                        139.00
                                                    </bdi>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={6} className="actions">
                                                <form
                                                    className="woocommerce-cart-form"
                                                    action="#"
                                                    method="post"
                                                >
                                                    <div className="ms-actions-inner">
                                                        <div className="coupon">
                                                            <input
                                                                type="text"
                                                                name="coupon_code"
                                                                className="input-text"
                                                                id="coupon_code"
                                                                defaultValue=""
                                                                placeholder="Coupon code"
                                                                required=""
                                                            />
                                                            <button
                                                                type="submit"
                                                                className="theme-btn btn-style sm-btn fill"
                                                                name="apply_coupon"
                                                                value="Apply coupon"
                                                            >
                                                                <span>Apply coupon</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col-md-5 offset-md-7">
                                        <div className="ms-cart-collaterals cart-collaterals">
                                            <div className="ms-cart-totals cart_totals ">
                                                <h3>Cart totals</h3>
                                                <table className="shop_table shop_table_responsive">
                                                    <tbody>
                                                        <tr className="cart-subtotal">
                                                            <th>Subtotal</th>
                                                            <td data-title="Subtotal">
                                                                <span className="woocommerce-Price-amount amount">
                                                                    <bdi>
                                                                        <span className="woocommerce-Price-currencySymbol">
                                                                            $
                                                                        </span>
                                                                        519.00
                                                                    </bdi>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr className="order-total">
                                                            <th>Total</th>
                                                            <td data-title="Total">
                                                                <strong>
                                                                    <span className="woocommerce-Price-amount amount">
                                                                        <bdi>
                                                                            <span className="woocommerce-Price-currencySymbol">
                                                                                $
                                                                            </span>
                                                                            519.00
                                                                        </bdi>
                                                                    </span>
                                                                </strong>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="ms-proceed-to-checkout wc-proceed-to-checkout">
                                                    <Link to="/checkout" className="theme-btn btn-style sm-btn fill">
                                                        <span>Proceed to checkout</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix" />
                    </div>
                </article>
            </div>
        </main>

    )
}

export default CartInner